export  const menuItems  = [
    {
      title: "Inicio",
      path: "/",
      subItems: []
    },
      {
      title: "Drones",
      path: "/drones",
      subItems: []
    },
       {
      title: "Habilitaciones de Bomberos",
      path: "/habilitacion-de-bomberos",
      subItems: []
    },{
      title: "Financiamiento",
      path: "/financiamiento",
      subItems: []
    },
    
    {
      title: "Contacto",
      path: "/#contacto",
      subItems: []
    }
  ];

   